import Header from "@/components/site/Header";
import Hero from "@/components/site/Hero";
import AboutMe from "@/components/site/AboutMe";
import ChangeSignals from "@/components/site/ChangeSignals";
import HowIHelp from "@/components/site/HowIHelp";
import Quiz from "@/components/site/Quiz";
import Sessions from "@/components/site/Sessions";
import ForWho from "@/components/site/ForWho";
import IntakeForm from "@/components/site/IntakeForm";
import FinalCta from "@/components/site/FinalCta";
import Footer from "@/components/site/Footer";

export default function Landing() {
  return (
    <main data-testid="landing-page" className="bg-[#F7F3F7] text-[#4B2F4F]">
      <Header />
      <Hero />
      <ChangeSignals />
      <AboutMe />
      <HowIHelp />
      <Quiz />
      <Sessions />
      <ForWho />
      <IntakeForm />
      <FinalCta />
      <Footer />
    </main>
  );
}
